// Counter

document.addEventListener("DOMContentLoaded", function() {
    const countElements = document.querySelectorAll('.count');

    const startCounting = (countElement) => {
        const targetNumber = parseInt(countElement.getAttribute('data-target'), 10);
        let currentNumber = 0;
        const increment = Math.ceil(targetNumber / 100); // Geschwindigkeit der Zählung
        const duration = 2000; // Zeit in Millisekunden
        const intervalTime = duration / (targetNumber / increment);

        const interval = setInterval(() => {
            currentNumber += increment;
            if (currentNumber >= targetNumber) {
                currentNumber = targetNumber;
                clearInterval(interval);
            }
            countElement.textContent = currentNumber;
        }, intervalTime);
    };

    const options = {
        root: null, // use the viewport as the container
        rootMargin: '0px',
        threshold: 0.1 // 10% des Elements müssen sichtbar sein
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                startCounting(entry.target); // Zählung starten
                observer.unobserve(entry.target); // stoppe die Beobachtung
            }
        });
    }, options);

    countElements.forEach(countElement => {
        observer.observe(countElement); // jedes Element beobachten
    });
});

// Viewport animation

function handleIntersection(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
        } else {
            entry.target.classList.remove('is-visible');
        }
    });
}

const options = {
    root: null, // Standardwert: viewport
    rootMargin: '0px',
    threshold: 0.1 // 10% des Elements müssen sichtbar sein
};

const observer = new IntersectionObserver(handleIntersection, options);

document.querySelectorAll('.animate').forEach(element => {
    observer.observe(element);
});